import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { paymentRepository } from '../repositories/payment.repository';
import { paymentKeys } from '../services/payments.keys';

export function useMarkPaymentPaid() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentId: string) => paymentRepository.markPaymentPaid(paymentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentKeys.all });
      toast({
        title: 'Payment marked as Paid successfully',
        description: 'The payment status has been updated.',
        variant: 'default',
      });
    },
    onError: (error: Error) => {
      console.error('Error marking payment as paid:', error);
      toast({
        title: 'Error updating payment',
        description: 'Failed to mark payment as paid. Please try again.',
        variant: 'destructive',
      });
    },
  });
}

export function useBulkMarkPaymentsPaid() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (paymentIds: string[]) => paymentRepository.bulkMarkPaymentsPaid(paymentIds),
    onSuccess: (count: number) => {
      queryClient.invalidateQueries({ queryKey: paymentKeys.all });
      toast({
        title: 'Payments updated successfully',
        description: `${count} payment${count > 1 ? 's have' : ' has'} been marked as paid.`,
        variant: 'default',
      });
    },
    onError: (error: Error) => {
      console.error('Error bulk updating payments:', error);
      toast({
        title: 'Error updating payments',
        description: 'Failed to mark payments as paid. Please try again.',
        variant: 'destructive',
      });
    },
  });
}

export function useUpdateOverduePayments() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (overduePaymentIds: string[]) =>
      paymentRepository.updateOverduePayments(overduePaymentIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: paymentKeys.all });
    },
    onError: (error: Error) => {
      console.error('Error updating overdue payments:', error);
    },
  });
}

